import { generateEncryptData } from "../helper/payloadHelper";
import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  GetHardwareName(payload) {
    return Api().post("/api/pos/gethardwarename", payload);
  },
  updateSeatStatus(payload) {
    return Api().put("/update-seat-status", payload);
  },
  getOrgDetails() {
    return Api().get("/api/pos/getOrgDetails");
  },
  getCashInput() {
    return Api().get(`/api/pos/cashinput`);
  },
  getCashDenominations() {
    return Api().get(`/api/pos/cashdenominations`);
  },
  getLebenonCashDenominations() {
    return Api().get(`/api/pos/lebenon/cashdenominations`);
  },
  onCloseShift(payload) {
    return Api().post(`/api/pos/shift_close`, payload);
  },
  getMovieDetails(payload) {
    return Api().post("/api/pos/getMovieDetails", payload);
  },
  getOccupancyStatus(payload) {
    return Api().post("/api/pos/getOccupancyStatus", payload);
  },
  getActiveScreens() {
    return Api().get("/api/pos/getActiveScreens");
  },
  UpdateCashCardAmount(payload) {
    return Api().put("/api/pos/updatecashcardamount", payload);
  },
  //This route using also for makeARefund in exhibitor
  getRefundReason(payload) {
    return Api().post("/api/pos/refund", payload);
  },
  //This route using also for makeARefund in exhibitor
  async updateRefundStatus(payload) {
    payload = await generateEncryptData(payload);
    return Api().put("/api/pos/generate-pos-bo-fnb-refund", payload);
  },
  _PaymentGatewayRefundApi_old(payload) {
    if (payload.pm_payment_mode == "Amazon PayFort")
      return Api().post("/api/cinema/pay-ford/refund-api", payload);
    else if (payload.pm_payment_mode == "Master/Visa")
      return Api().post("/api/cinema/master-card/refund-api", payload);
    else if (payload.pm_payment_mode == "Al Rajhi Bank")
      return Api().post("/api/cinema/alrajhi/refund-api", payload);
    else return Promise.reject(new Error("Invalid payment mode"));
  },
  PaymentGatewayRefundApi(payload) {
    if (payload.pm_payment_mode == "Amazon PayFort")
      return Api().post("/api/cinema/pay-ford/refund-api", payload);
    else if (payload.pm_payment_mode == "Master/Visa")
      return Api().post("/api/cinema/master-card/refund-api", payload);
    else if (payload.pm_payment_mode == "Al Rajhi Bank")
      return Api().post("/api/cinema/alrajhi/refund-api", payload);
    else if (payload.pm_payment_mode == "Secure Acceptance Checkout")
      return Api().post("/api/cinema/secure-acceptance/refund-api", payload);
    else if (payload.pm_payment_mode == "CC AVENUE")
      return Api().post("/api/cinema/cc-avenue/refund-api", payload);
    else if (payload.pm_payment_mode == "Bank Muscat")
      return Api().post("/api/cinema/bank-muscat/refund-api", payload);
    else if (payload.pm_payment_mode == "Khalti E-Payment")
      return Api().post("/api/cinema/khalti/refund-api", payload);
    else return Promise.reject(new Error("Invalid payment mode"));
  },
  AlrajhiInquiryPayment(payload) {
    return Api().post("/api/cinema/alrajhi/inquiry-payment", payload);
  },
  updateRefunds(payload) {
    //For Show Transactions
    return Api().put("/api/pos/refundstatus", payload);
  },
  updateFloatAmountRecord(payload) {
    return Api().put("/api/pos/cashinput", payload);
  },
  getAllShows(payload) {
    return Api().post("/api/pos/getAllShows", payload);
  },
  getSeatLayout(payload) {
    // return Api().post('/getSeatLayout', payload)
    // getYKSeatLayout
    return Api().post("/getYKSeatLayout", payload);
  },
  GetCustomerLoyaltyPointsBYID(payload) {
    return Api().get(
      `/api/pos/customerloyaltypoints/${payload.clp_id}?limit=${payload.limit}&currentPage=${payload.currentPage}`
    );
  },
  getSeatType(payload) {
    return Api().get(
      `/api/admin/tablelist/screen_seat_type?sst_is_active=Y&screen_id=${payload.screen_id}`
    );
  },
  getCustomersList(payload) {
    return Api().get(`/api/admin/tablelist/customers?cust_is_active=Y`);
  },
  getAllDates() {
    return Api().get("/api/pos/getAllDates");
  },
  getMovieLanguages() {
    return Api().get("/api/pos/getMovieLanguages");
  },
  getMovieGenre() {
    return Api().get("/api/pos/getMovieGenres");
  },
  getMovieFormats() {
    return Api().get("/api/pos/getMovieFormats");
  },
  AddCashCard(payload) {
    return Api().post("/api/pos/cashcard", payload);
  },
  reserveSeat(payload) {
    return Api().post("/reserveSeat", payload);
  },
  show_bookings(payload) {
    return Api().post("/api/pos/show_bookings", payload);
  },
  show_seat_bookings(payload) {
    return Api().post("/api/pos/show_seat_bookings", payload);
  },
  updateBookingStatus(payload) {
    return Api().post("/api/pos/updateBookingStatus", payload);
  },
  getBookingDetails(payload) {
    return Api().post("/api/pos/getBookingDetails", payload);
  },
  pickupTicket(payload) {
    return Api().post("/api/pos/pickup-ticket", payload);
  },
  GetReservationDetails(payload) {
    return Api().post("/api/pos/reservation-details", payload);
  },
  getAdditionalCharges(payload) {
    return Api().post("/api/pos/get-additional-charges", payload);
  },

  //Not using anywhere
  NewAdditionalCharges(payload) {
    return Api().post("/new-additional-charges", payload);
  },

  // POS
  PosBoxOfficeTransactions(payload) {
    return Api().post(`/pos/admin/transactions`, payload);
  },

  // New Booking APIs
  PosGetSeatLayout(payload) {
    return Api().post("/api/pos/v1.1/getSeatLayout", payload);
  },
  PosReserveSeat(payload) {
    return Api().post("/api/pos/v1.1/reserveSeats", payload);
  },
  releaseSeatIndividually(payload) {
    return Api().post("/api/pos/v1.1/releaseSeatIndividually", payload);
  },
  PosReleaseSeats(payload) {
    return Api().post("/api/pos/v1.1/releaseSeats", payload);
  },
  PosReleaseRealtimeSeats(payload) {
    return Api().post("/api/pos/v1.1/releaseRealtimeBookedSeats", payload);
  },
  async PosBookSeats(payload) {
    payload = await generateEncryptData(payload);
    return Api().post("/api/pos/generate-pos-bo-fnb-order", payload);
  },
  VerifyCardNumber(payload) {
    return Api().post("/api/pos/v1.1/verifycard", payload);
  },
  PosBookingDetails(payload) {
    return Api().post("/api/pos/v1.1/getBookingDetails", payload);
  },
  PosBookingDetailsEmpire(payload) {
    return Api().post("/api/pos/v1.1/getBookingDetailsEmpire", payload);
  },

  updateCustomerData(payload) {
    return Api().post("/api/pos/update-customer-data", payload);
  },
  sendCustomerOtpEmailForVerification(payload) {
    return Api().post("/api/cinema/sent-customer-otp-email", payload);
  },
  verifyOldCustomerEmailOTP(payload) {
    return Api().post("/api/cinema/verify-customer-otp-email", payload);
  },
  UpdateCustomerBookingDetails(payload) {
    return Api().post("/api/pos/update-customer-booking-details", payload);
  },

  InsertCustomerBookingDetails(payload) {
    return Api().post("/api/pos/insertCustomerDetails", payload);
  },
  InsertOnlyCustomerDetails(payload) {
    return Api().post("/api/pos/insertOnlyCustomerDetails", payload);
  },
  InsertGuestDetails(payload) {
    return Api().post("/pos/admin/guest_login", payload);
  },
  SendSMS(payload) {
    return Api().post("/api/pos/sendSMS", payload);
  },
  SendEmail(payload) {
    return Api().post("api/pos/sendEmail", payload);
  },
  // /api/pos/get-fnb-pricing
  GetFnbItemPricing(payload) {
    return Api().post("/api/pos/get-fnb-pricing", payload);
  },
  /**
   * POS BOOKING
   */
  OnStartPosUserShiftLog(payload) {
    return Api().post("/api/pos/pos-user-shift-log", payload);
  },
  // OnGetPosUserShiftLog(payload) {
  // },
  OnClosePosUserShiftLog(payload) {
    return Api().put("/api/pos/pos-user-shift-close", payload);
  },
  OnQuitPosUserShift(payload) {
    return Api().put("/api/pos/pos-user-shift-quit", payload);
  },
  // GetPosUsersShiftDetails() {
  //     return Api().get('/get-user-shift-close-logs');
  // }

  /**
   * POS BOOKING END
   */
  shiftChecker() {
    return Api().get("/api/pos/getshiftChecker");
  },

  GetTicketEjs(sb_id, cinema_id, isReprint = false) {
    return Api().get(
      `/api/pos/generate-ticket/${sb_id}/${cinema_id}?isReprint=${isReprint}`
    );
  },
  GetWOWTicketEjs(
    sb_id,
    cinema_id,
    OrderCode,
    isRefund = false,
    isReprint = false
  ) {
    return Api().get(
      `/api/pos/boplusfnb-ticket/${sb_id}/${cinema_id}/${OrderCode}/${isRefund}?isReprint=${isReprint}`
    );
  },
  GetRefundTicketEjs(sb_id, cinema_id, isReprint = false, isRefund = true) {
    return Api().get(
      `/api/pos/generate-refund-ticket/${sb_id}/${cinema_id}?isReprint=${isReprint}`
    );
  },

  GetAddonTicketEjs(payload) {
    let {
      addOns,
      bookingDetails,
      isReprint = false,
      isRefund = false,
    } = payload;
    return Api().get(
      `/api/pos/generate-addon-ticket?isReprint=${isReprint}&addOns=${addOns}&bookingDetails=${bookingDetails}&isRefund=${isRefund}`
    );
  },

  //new empire ticket
  GetEmpireTicketEjs(t_id, cinema_id, isReprint = false) {
    return Api().get(
      `/api/pos/generate-empire-ticket/${t_id}/${cinema_id}?isReprint=${isReprint}`
    );
  },

  GetTicketSecurityEjs(
    sb_id,
    cinema_id,
    isReprint = false,
    addOnsArr = [],
    isRefund = false
  ) {
    return Api().get(
      `/api/pos/generate-security-ticket/${sb_id}/${cinema_id}?isReprint=${isReprint}&addOnData=${addOnsArr}&isRefund=${isRefund}`
    );
  },
  GetBoxOffice_FnbTicketEjs(
    sb_id,
    ft_id = 0,
    cinema_id,
    flag,
    isReprint = false
  ) {
    console.log("1", ft_id);
    let ftId = ft_id ? ft_id : 0;
    return Api().get(
      `/api/pos/generate-receipt/${sb_id}/${ftId}/${cinema_id}?flag=${flag}&isReprint=${isReprint}`
    );
  },
  GetVoucherRedeemedEjs(sb_id, ft_id = 0, cinema_id, flag, isReprint = false) {
    console.log("1", ft_id);
    let ftId = ft_id ? ft_id : 0;
    return Api().get(
      `/api/pos/generate-voucher-redeemed-receipt/${sb_id}/${ftId}`
    );
  },
  GetReceiptEjs(sb_id, ft_id = 0, cinema_id, flag) {
    console.log("2", ft_id);
    let ftId = ft_id ? ft_id : 0;
    return Api().get(
      `/api/pos/generate-receipt/${sb_id}/${ftId}/${cinema_id}?flag=${flag}`
    );
  },
  //get Cash Cards
  GetCashCards(payload) {
    return Api().get(`/api/pos/getcashcards/${payload.customer_id}`);
  },
  GetCashCardLogs(payload) {
    const { cash_card_id } = payload;
    const query = createQueryString(payload);
    return Api().get(`/api/pos/getcashcardlogs/${cash_card_id}/${query}`);
  },
  CheckBalance(cash_card_id) {
    return Api().get(`/api/pos/checkcashcardbalance/${cash_card_id}`);
  },
  ValidateBalance(payload) {
    return Api().post(`/api/pos/checkusedcashcardbalance`, payload);
  },
  //get valid payment modes
  GetValidPaymentModes(payload) {
    const CINEMA_ID = localStorage.getItem("cinema_id");
    return Api().get(
      `/api/pos/getvalidpaymentmodes/${payload}${
        CINEMA_ID ? `?cinema_id=${CINEMA_ID}` : ""
      }`
    );
  },
  async ValidatePoints(payload) {
    payload = await generateEncryptData(payload);
    return Api().post("/api/pos/v2/validate_points", payload);
  },
  ValidateUPPLoyalityPoints(payload) {
    return Api().post("/api/cinema/validate_upp_points", payload);
  },
  GetUppLoyalityBalance(payload) {
    return Api().get(`/api/cinema/get_balance/${payload.customer_id}`);
  },
  ValidateUppCashback(payload) {
    return Api().post("/api/cinema/upp_loyality/validate_cashback", payload);
  },
  //Shifted from userservice
  CheckCinemaManagerLogin(payload) {
    return Api().post("/api/pos/checkCinemaManagerLogin", payload);
  },
  //Shifted from userservice
  CheckCinemaManagerAuth(payload) {
    return Api().post("/api/pos/checkCinemaManagerAuth", payload);
  },
  CashDrawerLogs(payload) {
    return Api().post("/api/pos/cashDrawerLogs", payload);
  },
  //Shifted from scheduleService
  getReservesSeatLayout(payload) {
    return Api().post("/api/pos/getSeatLayout", payload);
  },
  //GetMenus
  GetPosFooterMenus() {
    return Api().get("/api/pos/posfootermenus");
  },
  ConvertCurrency(payload) {
    return Api().post("/api/admin/convert-currency", payload);
  },
  GetFnbOrderDetails(payload) {
    return Api().get(`/pos/admin/checkRefund/${payload.order_code}`);
  },
  async fnbRefund(payload) {
    payload = await generateEncryptData(payload);
    return Api().post(`/pos/generate-only-fnb-refund`, payload);
  },
  getPosUserCollection(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/pos/getUserCollection/${payload.user_id}${query}`);
  },
  getShiftCloseInvoiceSummary(payload) {
    const query = createQueryString(payload);
    return Api().get(
      `api/pos/shiftCloseInvoiceSummary/${payload.user_id}${query}`
    );
  },
  getPosUserTransactions(payload) {
    const query = createQueryString(payload);
    return Api().post(
      `/api/pos/getUserTransaction/${payload.user_id}`,
      payload
    );
  },
  insertCustomerBooking(payload) {
    return Api().post(`/api/pos/updateCustomerBooking`, payload);
  },
  AddComment(payload) {
    return Api().post(`/api/pos/updateTransactionComment`, payload);
  },
  GetCashCardList(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/pos/getcashcardlist/${query}`);
  },
  TopUpCashCard(payload) {
    return Api().post(`/api/pos/credit-cash-card`, payload);
  },
  getCashCardReceipt(payload) {
    return Api().get(
      `/api/pos//cash_card_receipt/${payload.cash_card_id}/${payload.cash_card_log_id}?isReprint=${payload.isReprint}`
    );
  },
  getWalletReceipt(payload) {
    return Api().get(`/api/e_wallet/print/${payload.topup_code}`);
  },
  getCashCardTopupDetails(payload) {
    return Api().get(`/api/pos/cash_card_trx_details/${payload.topup_code}`);
  },
  getRateCardAddonsByReservation(payload) {
    return Api().get(
      `/api/admin/get-rate-card-addons-by-id?reservation_id=${payload.reservation_id}`
    );
  },
  GetPosLocationsUsers(payload) {
    return Api().get(`/api/pos/getUserOtherLocations/${payload.user_id}`);
  },
  changeLoggedUserCinema(payload) {
    return Api().post(`/api/pos/changePosUserCinema`, payload);
  },
  getTLLOgs(payload) {
    return Api().get(`/api/admin/v2/tl-logs/${payload.usl_id}`);
  },

  getScheduleDetail(payload) {
    return Api().get(`/api/cinema/schedule-details/${payload.ss_id}`);
  },
  getScheduleDetailPos(payload) {
    return Api().get(`/api/cinema/schedule-details-pos/${payload.ss_id}`);
  },
  getReservationDetail(payload) {
    return Api().get(`/api/pos/reservation-detail/${payload.reservation_id}`);
  },
  getFnbReservationDetails(payload) {
    return Api().post(`/pos/admin/getReservedFnbDetails`, payload);
  },
  getPosShiftInvoice(payload) {
    let query = createQueryString(payload);
    return Api().get(
      `/api/pos/shiftCloseInvoiceSummary/${payload.user_id}${query}`
    );
  },
  getWebsitePosBookingDetails(payload) {
    return Api().get(`/api/cinema/booking-details/${payload.bookingCode}`);
  },
  // CHECK_LIMIT_REPRINT(payload) {
  //   let qs = ``;
  //   if (payload.onlyCheck) {
  //     qs = `?onlyCheck=${payload.onlyCheck}`;
  //   }
  //   return Api().get(`/api/pos/checkReprintExist/${payload.sb_id}${qs}`);
  // },
  CHECK_LIMIT_REPRINT(payload) {
    let qs = ``;
    if (payload.onlyCheck) {
      qs = `?onlyCheck=${payload.onlyCheck}`;
    }
    return Api().get(
      `/api/pos/checkReprintExist/${payload.sb_id}${qs}`,
      payload
    );
  },
  // CHECK_LIMIT_REPRINT_FNB(payload) {
  //   let ftId =
  //     payload.hasOwnProperty("ft_id") && payload["ft_id"]
  //       ? payload.ft_id
  //       : null;

  //   let extraQuery = ``;
  //   if (ftId) {
  //     extraQuery = `?ft_id=${ftId}`;
  //   }
  //   return Api().get(
  //     `/api/pos/checkReprintExistFnb/${payload.orderCode}${extraQuery}`
  //   );
  // },
  CHECK_LIMIT_REPRINT_FNB(payload) {
    let ftId =
      payload.hasOwnProperty("ft_id") && payload["ft_id"]
        ? payload.ft_id
        : null;

    let extraQuery = ``;
    if (ftId) {
      extraQuery = `?ft_id=${ftId}`;
    }
    return Api().get(
      `/api/pos/checkReprintExistFnb/${payload.orderCode}${extraQuery}`,
      payload
    );
  },
  getQfxEntrancePass(payload) {
    let qs = "";
    if (payload.t_id) {
      qs = `?t_id=${payload.t_id}`;
    }
    return Api().get(`/api/pos/generate-entrance-ticket/${payload.sb_id}${qs}`);
  },
  getEntrancePass(payload) {
    let qs = "";
    if (payload.t_id) {
      qs = `?t_id=${payload.t_id}`;
    }
    return Api().get(
      `/api/pos/generate-single-ticket/${payload.sb_id}/${payload.cinema_id}${qs}`
    );
  },
  getSingleSeatTicket(payload) {
    return Api().get(
      `/api/pos/generate-single-seat-ticket/${payload.t_id}/${payload.cinema_id}`
    );
  },
  ValidateEWalletCustomer(payload) {
    return Api().post(`/api/e_wallet/send_otp`, payload);
  },
  async VerifyEWalletCustomerByOtp(payload) {
    payload = await generateEncryptData(payload);
    return Api().post(`/api/e_wallet/pos/v2/verify_otp/balance`, payload);
  },
  getWalletBalance(payload) {
    return Api().post(`/api/e_wallet/getbalance`, payload);
  },
  TopUpWallet(payload) {
    return Api().post(`/api/e_wallet/recharge`, payload);
  },
  getWalletTopupDetails(payload) {
    return Api().get(`/api/e_wallet/trx_details/${payload.topup_code}`);
  },
  VerifyUppCustomerByOtp(payload) {
    return Api().post(`/api/cinema/upp_loyality/verify_otp`, payload);
  },
  getCinemaWiseStoreList(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/pos/store_management${query}`);
  },
  updateUserStoreManagement(payload) {
    return Api().put(`/api/pos/updateStoreManagement`, payload);
  },
  async createCCIntent(payload) {
    payload = await generateEncryptData(payload);
    return Api().post(
      `/api/cinema/v2/create-cc-avenue-pos-intent/${payload.reservation_id}`,
      payload
    );
  },
  async createAlrajhiIntent(payload) {
    payload = await generateEncryptData(payload);
    return Api().post(
      `/api/cinema/v2/create-alrajhi-pos-intent/${payload.reservation_id}`,
      payload
    );
  },
  checkAlrajhiPaymentStatus(payload) {
    return Api().get(
      `/api/cinema/alrajhi-pos-payment-status/${payload.reservation_id}`
    );
  },
  checkCCAvenuePaymentStatus(payload) {
    return Api().get(
      `/api/cinema/proxy/cc-avenue/pos-payment-status/${payload.reservation_id}`
    );
  },
  ValidateBankCard(payload) {
    return Api().post(`/api/pos/validate_offer_bank_card`, payload);
  },
  ReduceThePriceForComplimentory(payload) {
    return Api().post(`/api/pos/calculate_complimentary_price`, payload);
  },
  GetCinepolisTicketEjs(payload) {
    return Api().get(
      `/api/pos/boplusfnb-ticket/${payload.sb_id ? payload.sb_id : 0}/${
        payload.cinema_id
      }/${payload.OrderCode ? payload.OrderCode : 0}/${
        payload.isRefund ? payload.isRefund : false
      }?isReprint=${payload.isReprint}`
    );
  },
  GetPlatinumInvoice(payload) {
    return Api().get(
      `/api/pos/platinum-bo=fnb-ticket?isSeats=${
        payload.isSeats || "N"
      }&isInvoice=${payload.isInvoice || "N"}`
    );
  },
  GetPlatinumTicketSeat(payload) {
    return Api().get(`/api/ticket/platinum-seat-ticket/${payload.t_id}`);
  },

  // GetCinepolisTicketEjs(payload) {
  //   return Api().post(`/api/pos/boplusfnb-ticket`, payload);
  // },
  // GetCinepolisTicketEjs(sb_id, cinema_id, OrderCode, isReprint = false) {
  //   return Api().get(
  //     `/api/pos/boplusfnb-ticket/${sb_id}/${cinema_id}/${OrderCode}?isReprint=${isReprint}`
  //   );
  // },
  GetPosMoviePassList(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/pos/available-movie-pass${query}`);
  },
  ReserveMoviePass(payload) {
    return Api().post(`/api/pos/reserve-movie-pass`, payload);
  },
  GetReserveMoviePass(payload) {
    return Api().get(
      `/api/pos/get-reserve-movie-pass/${payload.reservation_id}`
    );
  },
  BookMoviePass(payload) {
    return Api().post(`/api/pos/book-movie-pass`, payload);
  },
  getMoviepassBookingDetails(payload) {
    return Api().get(`/api/pos/get-pass-booking-details/${payload.trx_code}`);
  },
  SendMoviePassOTP(payload) {
    return Api().post(`/api/movie-pass/send_otp`, payload);
  },
  ValidMoviePassOTP(payload) {
    return Api().post(`/api/movie-pass/verify_otp`, payload);
  },
  VerifyMoviePass(payload) {
    return Api().post(`/api/movie-pass/apply-movie-pass`, payload);
  },
  getMoviePassReceipt(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/movie-pass/print/${payload.trx_code}${query}`);
  },
  GetScheduleWiseTransactions(payload) {
    return Api().post(`/api/pos/getScheduleWiseSalesInfo`, payload);
  },
  // getBoFnbSingleTicketApi(payload) {
  //   return Api().get(
  //     `/api/print-bo-fnb-ticket/${payload.sb_id}/${payload.ft_id}?ticket_print_type=${payload.ticket_print_type}`
  //   );
  // },
  getBoFnbSingleTicketApi(payload) {
    return Api().get(
      `/api/print-bo-fnb-ticket/${payload.sb_id}/${
        payload.ft_id
      }?ticket_print_type=${payload.ticket_print_type}&print_taken_type=${"BO"}`
    );
  },
  GetMerchandiseList(payload) {
    return Api().post(`/api/pos/get-merchandise-list`, payload);
  },
  ReserveCartItems(payload) {
    return Api().post(
      `/api/pos/reserve-merchandise/${payload.reservation_id}`,
      payload
    );
  },
  GetReserveMerchandiseDetails(payload) {
    return Api().post(
      `/api/pos/get-merchandise-reservation/${payload.reservation_id}/${payload.key_id}`,
      payload
    );
  },
  BookMerchandise(payload) {
    return Api().post(`/api/pos/purchase-merchandise`, payload);
  },
  GetMerchandiseBookingDetails(payload) {
    return Api().post(
      `/api/pos/get-merchandise-booking/${payload.trx_code}/${payload.trx_id}`,
      payload
    );
  },
  GetMerchandiseReceipt(payload) {
    return Api().get(
      `/api/print/get-merchandise-receipt/${payload.trx_code}/${payload.trx_id}`
    );
  },
  VerifyMerchandiseVoucher(payload) {
    return Api().post(`/api/pos/verify/merchandise-voucher`, payload);
  },
  checkLocalCacheKey(payload) {
    return Api().get(`/api/pos/cache/local/key`);
  },

  createFonePayIntent(payload) {
    return Api().post(
      `/api/cinema/create-fonePayQr-intent/${payload.reservation_id}`,
      payload
    );
  },
  checkFonePayQrPaymentStatus(payload) {
    return Api().get(
      `/api/cinema/check-fonePayQr-status/${payload.reservation_id}`
    );
  },
  checkFonePayQrOnlyFnbPaymentStatus(payload) {
    return Api().post(
      `/api/cinema/check-fonePayQr-onlyFnb-intent/${payload.reservation_id}`,
      payload
    );
  },
  getCountryStates(country_id = null) {
    return Api().get(
      `/api/get_ms_states_list?state_is_active=Y&country_id=${country_id}`
    );
  },
  InsertCardMachineLogs(payload) {
    return Api().post(`/api/pos/card_machine_logs`, payload);
  },
  GenerateQRISCode(payload) {
    return Api().post(`/api/admin/create-qris-code`, payload);
  },
  GetQRISPaymentStatus(payload) {
    return Api().get(
      `/api/admin/qris-code-payment-status/${payload.reservation_id}`,
      payload
    );
  },
  GetBanksList(payload) {
    return Api().get("/api/marketing/bank-list");
  },
  ProceedCreditCardPayment(payload) {
    return Api().post(
      `/api/cinema/master-card-asf/proceed-card-payment`,
      payload
    );
  },
  generateDynamicVoucherPrint(payload) {
    return Api().get(
      `/api/dynamic-voucher-print/${payload.sb_id}/${payload.ft_id}`
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/PosService.js